import { render, staticRenderFns } from "./MyClient.vue?vue&type=template&id=5045f7c2&scoped=true&"
import script from "./MyClient.vue?vue&type=script&lang=js&"
export * from "./MyClient.vue?vue&type=script&lang=js&"
import style0 from "./MyClient.vue?vue&type=style&index=0&id=5045f7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045f7c2",
  null
  
)

export default component.exports